import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { MonthProvider } from "@/context/MonthContext";
import { Toaster } from "@/components/ui/sonner";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Companies from "@/pages/Companies";
import Managers from "@/pages/Managers";
import Employees from "@/pages/Employees";
import Transactions from "@/pages/Transactions";
import ManagerExpenses from "@/pages/ManagerExpenses";
import PartnerShares from "@/pages/PartnerShares";
import Dagitim from "@/pages/Dagitim";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Yükleniyor…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RoleGate({ allowed, children }) {
  const { user } = useAuth();
  if (!user) return null;
  const role = user.role;
  if (allowed && !allowed.includes(role)) {
    const home = role === "accountant" ? "/islemler" : "/";
    return <Navigate to={home} replace />;
  }
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Yükleniyor…</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <MonthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<PublicOnly><Login/></PublicOnly>} />
              <Route element={<Protected><AppLayout/></Protected>}>
                <Route path="/" element={<RoleGate allowed={["admin","partner","employee"]}><Overview/></RoleGate>} />
                <Route path="/firmalar" element={<RoleGate allowed={["admin","partner","employee"]}><Companies/></RoleGate>} />
                <Route path="/yoneticiler" element={<RoleGate allowed={["admin","partner","employee"]}><Managers/></RoleGate>} />
                <Route path="/calisanlar" element={<RoleGate allowed={["admin","partner","employee"]}><Employees/></RoleGate>} />
                <Route path="/islemler" element={<Transactions/>} />
                <Route path="/yonetici-giderleri" element={<RoleGate allowed={["admin","partner","employee"]}><ManagerExpenses/></RoleGate>} />
                <Route path="/ortaklar" element={<RoleGate allowed={["admin","partner","employee"]}><PartnerShares/></RoleGate>} />
                <Route path="/dagitim" element={<RoleGate allowed={["admin","partner","employee"]}><Dagitim/></RoleGate>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace/>} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
        </MonthProvider>
      </AuthProvider>
    </div>
  );
}
